// providers
import { UserProvider } from "providers/UserProvider";
import { QueryClient, QueryClientProvider } from "react-query";
import DeviceOrientation, { Orientation } from "react-screen-orientation";

// components
import ThemedApp from "ThemedApp";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemedApp />
    </QueryClientProvider>
  );
}

//           {/* <UserProvider> */}

//           {/* </UserProvider> */}
//         {/* </QueryClientProvider> */}

export default App;
